import { useConnection } from "@solana/wallet-adapter-react";
import { GmClientService } from "@staratlas/factory";
import type { StarAtlasOpenOrder } from "@stepfinance/dex";
import { StarAtlasPositionFetcher } from "@stepfinance/dex";
import { useEffect, useMemo, useState } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useMarkets } from "../../contexts/market";

export const gmClientService = new GmClientService();

export const useStarAtlasOrders = (): StarAtlasOpenOrder[] => {
  const { connection } = useConnection();
  const { publicKey } = useEnrichedWallet();
  const [orders, setOrders] = useState<StarAtlasOpenOrder[]>([]);
  const { priceInUSD, marketsInitialised } = useMarkets();

  const fetcher = useMemo(() => {
    if (!publicKey) {
      return undefined;
    }
    return new StarAtlasPositionFetcher(publicKey, connection);
  }, [connection, publicKey]);

  useEffect(() => {
    if (!publicKey) {
      setOrders([]);
    } else if (fetcher && marketsInitialised) {
      void fetcher.fetchPositions(priceInUSD).then(setOrders);
    }
  }, [publicKey, connection, fetcher, priceInUSD, marketsInitialised]);

  return orders;
};
